import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import TextInput from 'components/Inputs/TextInput/TextInput';
import FormValidator from 'utils/FormValidator';
import ErrorConstants from 'utils/ErrorConstants';
import ErrorsUtils from 'utils/Errors';
import localeUtils from 'utils/LanguageLocale';

function CityField({
    city = '',
    cityStateZipInvalid = false,
    isFCFinalReleaseEnabled = false,
    isSubscription = false,
    modalTitle = '',
    localization = {},
    onChange,
    cityInputRef,
    fireFormErrorAnalytics
}) {
    const { cityText } = localization;
    const isUS = localeUtils.isUS();
    const isAdsRestricted = false; // disabled as validated on CE

    const maxLength = isAdsRestricted ? FormValidator.FIELD_LENGTHS.cityAdsRestricted : FormValidator.FIELD_LENGTHS.city;

    const validateCity = cityValue => {
        if (FormValidator.isEmpty(cityValue)) {
            if (isSubscription && fireFormErrorAnalytics) {
                fireFormErrorAnalytics(modalTitle, ErrorsUtils.getMessage(ErrorConstants.ERROR_CODES.CITY));
            }

            return ErrorConstants.ERROR_CODES.CITY;
        }

        if (!FormValidator.isValidLength(cityValue, 1, maxLength)) {
            if (isSubscription && fireFormErrorAnalytics) {
                const errorCode = isAdsRestricted ? ErrorConstants.ERROR_CODES.CITY_ADS_LONG : ErrorConstants.ERROR_CODES.CITY_LONG;
                fireFormErrorAnalytics(modalTitle, ErrorsUtils.getMessage(errorCode));
            }

            return isAdsRestricted ? ErrorConstants.ERROR_CODES.CITY_ADS_LONG : ErrorConstants.ERROR_CODES.CITY_LONG;
        }

        return null;
    };

    return (
        <TextInput
            name='city'
            autoComplete='address-level2'
            autoCorrect='off'
            onChange={onChange}
            label={cityText}
            required={true}
            hideAsterisk={isUS || isFCFinalReleaseEnabled}
            maxLength={maxLength}
            invalid={cityStateZipInvalid}
            value={city}
            ref={cityInputRef}
            validateError={validateCity}
            data-at={Sephora.debug.dataAt('city_input')}
        />
    );
}

export default wrapFunctionalComponent(CityField, 'CityField');
